import { render } from "./instance.vue?vue&type=template&id=3bcc996c&scoped=true"
import script from "./instance.js?vue&type=script&lang=js"
export * from "./instance.js?vue&type=script&lang=js"

import "./instance.vue?vue&type=style&index=0&id=3bcc996c&lang=less&scoped=true"

import exportComponent from "E:\\Workspace\\daifu\\daifu_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bcc996c"]])

export default __exports__